<script>
export default {
    name: "VacancyListItem",

    props: {
        item: {
            type: {
                id: {
                    type: Number,
                    required: true
                },
                title: {
                    type: String,
                    required: true
                },
                salary: {
                    type: String,
                    required: true
                },
                city: {
                    type: String,
                    required: true
                },
                hours: {
                    type: String,
                    required: true
                },
                url: {
                    type: String,
                    required: true
                },
                excerpt: {
                    type: String,
                    required: false
                },
                job_type: {
                    type: String,
                    required: false
                },
                image: {
                    type: String,
                    required: false
                }
            },
            required: true
        }
    },

    computed: {
        image() {
            if (_.isEmpty(this.item.image)) {
                return '/themes/custom/ef2_custom/img/occasion-placeholder.jpg';
            }

            return this.item.image;
        },
    },
    methods: {
        goToVacancy() {
            window.location = this.item.url;
        }
    }
}
</script>

<template>
    <div class="occasion-teaser-item vacancy-teaser-item" @click="goToVacancy">
        <div class="inner">
            <div class="row">
                <div class="col-md-4 teaser-image">
                    <img class="h-100 w-full" :src="image" alt="" width="245" height="175">
                </div>
                <div class="col-md-8">
                    <h3 class="occasion-title"><a :href="item.url">{{ item.title }}</a></h3>

                    <div class="intro-information">
                        <div class="price info-item">{{ item.job_type }}</div>
                        <div class="info-item">{{ item.city }}</div>
                        <div class="info-item">{{ item.hours }}</div>
                    </div>

                    <div class="extra-information">
                        <p class="info-item mb-0">{{ item.excerpt }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

